import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import Select from "react-select";

interface Props {
  handleChange?: (value: string) => void;
  state?: any;
}

export default function ItemsCount({ handleChange, state }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const itemsPerPage = Number(searchParams.get("itemsPerPage") || "25");

  const { t } = useTranslation();

  const cardsCountOptions = [
    {
      label: "All",
      value: "0",
    },
    {
      label: "25",
      value: "25",
    },
    {
      label: "50",
      value: "50",
    },
    {
      label: "75",
      value: "75",
    },
    {
      label: "100",
      value: "100",
    },
  ];

  return (
    <div className="flex items-center gap-1">
      <h3 className="w-20 text-sm">{t("cards_count")}:</h3>
      <Select
        className="w-28"
        options={cardsCountOptions}
        value={cardsCountOptions.find(
          (option) => 
            // if (state){
            //   return +option.value == state ? true : false;
            // } else {
            //   return +option.value == itemsPerPage ? true : false;
            // }
            state ? +option.value == state : +option.value == +itemsPerPage
          
        )}
        onChange={(selectedOption) => {
          if (handleChange) {
            handleChange(selectedOption?.value.toString() || "25");
            return;
          }

          setSearchParams((prev) => {
            prev.set("itemsPerPage", selectedOption?.value.toString() || "25");
            prev.set("page", "1");
            return prev;
          });
        }}
      />
    </div>
  );
}
